export const APP_TIMEZONE = 'Europe/London';
export const DEFAULT_TEXT = "-";
export const DEFAULT_CURRENCY_TEXT = "--.--";
export const UNLIMITED_PAGE_COUNT = 999999;
